import store from '../store'
import axios from "axios"

const instance = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? '/sw' : process.env.VUE_APP_BASE_URL,
  baseURL: process.env.VUE_APP_BASE_URL,
  headers: {contentType: 'application/json'}
})

instance.interceptors.request.use(function (config) {
  try {
    config.headers.token = store.state.token
  } catch(err) {
    console.log(err)
  }
  return config
}, function (error) {
  return Promise.reject(error);
})

instance.interceptors.response.use(function (response) {
  if (response.data.code === 10020) {
    store.dispatch('setShowLoginPop', true).then()
  }
  return response;
}, function (error) {
  return Promise.reject(error);
})

export default instance
